(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["final-dough-temperature-calculator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('final-dough-temperature-calculator')) {
    customElements.define('final-dough-temperature-calculator', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-form]');
        this.target = this.querySelector('[data-target]');
        this.room = this.querySelector('[data-room]');
        this.flour = this.querySelector('[data-flour]');
        this.starter = this.querySelector('[data-starter]');
        this.method = this.querySelector('[data-method]');
        this.friction = this.querySelector('[data-friction]');
        this.result = this.querySelector('[data-result]');
        this.cue = this.querySelector('[data-cue]');
        this.note = this.querySelector('[data-note]');
        this.equation = this.querySelector('[data-equation]');
        this.error = this.querySelector('[data-error]');
        this.resetButton = this.querySelector('[data-reset]');
        this.defaults = { target: 26, room: 24, flour: 24, starter: 24, method: 'hand', friction: 0 };

        this.form.addEventListener('input', (event) => {
          if (event.target === this.friction) {
            const expected = this.method.value === 'hand' ? 0 : this.method.value === 'mixer' ? 15 : Number(this.friction.value);
            if (Number(this.friction.value) !== expected) this.method.value = 'custom';
          }
          this.calculate();
        });

        this.method.addEventListener('change', () => {
          if (this.method.value === 'hand') this.friction.value = 0;
          if (this.method.value === 'mixer') this.friction.value = 15;
          this.calculate();
        });

        this.resetButton.addEventListener('click', () => this.reset());
        this.calculate();
      }

      format(value) {
        return Number.isInteger(value) ? String(value) : value.toFixed(1);
      }

      calculate() {
        const values = {
          target: Number(this.target.value),
          room: Number(this.room.value),
          flour: Number(this.flour.value),
          starter: Number(this.starter.value),
          friction: Number(this.friction.value)
        };
        const inputs = [this.target, this.room, this.flour, this.starter, this.friction];
        inputs.forEach((input) => input.removeAttribute('aria-invalid'));

        const invalid = inputs.filter((input) => input.value === '' || !input.checkValidity());
        if (invalid.length) {
          invalid.forEach((input) => input.setAttribute('aria-invalid', 'true'));
          this.error.textContent = 'Enter a valid temperature in every field. The friction factor must be between 0°C and 30°C.';
          this.error.hidden = false;
          this.result.textContent = '—';
          this.cue.textContent = 'Check your inputs';
          this.note.textContent = 'The result will appear when every temperature is valid.';
          this.equation.textContent = 'Waiting for valid temperatures';
          return;
        }

        this.error.hidden = true;
        const water = (values.target * 4) - values.room - values.flour - values.starter - values.friction;
        const roundedWater = Math.round(water * 10) / 10;
        this.result.textContent = `${this.format(roundedWater)}°C`;
        this.equation.textContent = `(${this.format(values.target)} × 4) − ${this.format(values.room)} − ${this.format(values.flour)} − ${this.format(values.starter)} − ${this.format(values.friction)} = ${this.format(roundedWater)}°C`;

        if (roundedWater < 0) {
          this.cue.textContent = 'Below freezing';
          this.note.textContent = 'These inputs call for water below 0°C. Recheck the temperatures and use chilled water or ice as appropriate.';
        } else if (roundedWater < 10) {
          this.cue.textContent = 'Very cold water';
          this.note.textContent = 'Use this as your starting water temperature, then measure the dough immediately after mixing.';
        } else if (roundedWater < 20) {
          this.cue.textContent = 'Cool water';
          this.note.textContent = 'Use this as your starting water temperature, then measure the dough immediately after mixing.';
        } else if (roundedWater < 30) {
          this.cue.textContent = 'Mild water';
          this.note.textContent = 'Use this as your starting water temperature, then measure the dough immediately after mixing.';
        } else if (roundedWater <= 50) {
          this.cue.textContent = 'Warm water';
          this.note.textContent = 'Use this as your starting water temperature, then measure the dough immediately after mixing.';
        } else {
          this.cue.textContent = 'Very warm water';
          this.note.textContent = 'Recheck your inputs before mixing. Avoid pouring very hot water directly onto your starter.';
        }
      }

      reset() {
        this.target.value = this.defaults.target;
        this.room.value = this.defaults.room;
        this.flour.value = this.defaults.flour;
        this.starter.value = this.defaults.starter;
        this.method.value = this.defaults.method;
        this.friction.value = this.defaults.friction;
        this.calculate();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-editorial"] && !Shopify.designMode) return;
  try {
    
  const initialiseEditorialCarousel = (section) => {
    if (section.dataset.carouselInitialised === 'true') return;

    const track = section.querySelector('[data-carousel-track]');
    const previous = section.querySelector('[data-carousel-previous]');
    const next = section.querySelector('[data-carousel-next]');

    if (!track || !previous || !next) return;

    const getScrollAmount = () => {
      const card = track.querySelector('.homepage-editorial__card');
      if (!card) return track.clientWidth;
      const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    };

    const updateControls = () => {
      const remaining = track.scrollWidth - track.clientWidth - track.scrollLeft;
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = remaining <= 2;
    };

    previous.addEventListener('click', () => {
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    section.dataset.carouselInitialised = 'true';
    updateControls();
  };

  const initialiseEditorialSections = (root = document) => {
    root.querySelectorAll('[data-homepage-editorial]').forEach(initialiseEditorialCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseEditorialSections());
  } else {
    initialiseEditorialSections();
  }
  document.addEventListener('shopify:section:load', (event) => initialiseEditorialSections(event.target));

  } catch(e) { console.error(e); }
})();
})();
